exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style__body___3uwpm {\n  font-size: 16px; }\n  .style__body___3uwpm .style__big___a44U8 {\n    font-size: 22px; }\n  .style__body___3uwpm .style__emp___2sb4D {\n    font-weight: 400; }\n  .style__body___3uwpm .style__left___1YC2M {\n    text-align: left; }\n  .style__body___3uwpm li {\n    margin: 10px 20px; }\n", ""]);

// exports
exports.locals = {
	"body": "style__body___3uwpm",
	"big": "style__big___a44U8",
	"emp": "style__emp___2sb4D",
	"left": "style__left___1YC2M"
};